// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"82299c8f","879":"dfe7b6d9"}[chunkId] + ".chunk.js";
};